declare var x_textos: any;

/**
 * Función helper segura para obtener textos
 * Previene errores cuando x_textos no está disponible
 */
function getText(key: string, defaultValue: string = ''): string {
	if (typeof x_textos === 'undefined' || x_textos === null) {
		console.warn(`x_textos no está disponible. Clave solicitada: ${key}`);
		return defaultValue;
	}
	if (typeof x_textos[key] === 'undefined') {
		console.warn(`Texto no encontrado para la clave: ${key}`);
		return defaultValue;
	}
	return x_textos[key];
}

export class Comentarios {
	/** constructor */
	constructor() {

	}

	setVerMas() {
		// Verificar que x_textos esté disponible antes de continuar
		if (typeof x_textos === 'undefined' || x_textos === null) {
			console.warn('Comentarios.setVerMas: x_textos no está disponible, reintentando...');
			// Reintentar después de un breve delay
			setTimeout(() => this.setVerMas(), 100);
			return;
		}

		$(".testimonio .valor").each(function () {
			const $comentario = $(this);
			if ($comentario.has('.ver-mas').length) return;

			const text = $comentario.text().trim();
			const screenWidth = $(window).width();
			let maxLength = 90;

			if (screenWidth && screenWidth > 1000 && screenWidth < 1200) {
				maxLength = 90;
			} else if (screenWidth && screenWidth > 1200 && screenWidth < 1300) {
				maxLength = 110;
			} else {
				maxLength = 130;
			}

			if (text.length > maxLength) {
				// Usar función helper segura en lugar de acceso directo
				const verMasText = getText('390-0', 'Ver más');
				const $verMas = $(`<span class="ver-mas text-primary">${verMasText}</span>`);
				$comentario.html(text.slice(0, maxLength) + '...').append($verMas);
				$verMas.on('click', function () {
					$comentario.text(text);
				});
			}
		});
	}
}